import { TextField } from '@mui/material';
import { Row } from 'antd';
import Acent from "components/Acent";
import React, { memo, useRef } from 'react';


const MatchMakingText = ({ value, onTextChange = () => {}, style = {} , optId  }) => {
    const dispNameRef = useRef();

    return (
        <div style={style}>
            <Row justify="end" style={{ marginBottom: 10 }}>
            <Acent inputRef={dispNameRef} setValue={v => onTextChange(v)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                    <TextField
                        id="Answer"
                        name="Answer"
                        label={`Answer ${optId+1}`}
                        InputLabelProps={{ shrink: true, required: true }}
                        type="text"
                        inputRef={dispNameRef}
                        required
                        variant="outlined"
                        onChange={e => {
                            onTextChange(e.target.value)
                        }}
                        value={value}
                    />
            </Row>
        </div>
    )
}


export default memo(MatchMakingText);